import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;
/** Which form look-ups are switched on — each needs its key on the server, so until then nothing shows. */
export function useLookups() {
  const [on, setOn] = useState({ company: false, address: false });
  useEffect(() => {
    cached = cached || api.get("/lookup/status").then((r) => r.data).catch(() => ({ company: false, address: false }));
    let live = true;
    cached.then((d) => live && setOn(d));
    return () => { live = false; };
  }, []);
  return on;
}

/** Debounced search that keeps only the latest answer. */
export function useSearch(path, q, min) {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    const v = (q || "").trim();
    if (!path || v.length < min) { setItems([]); setError(""); return undefined; }
    let live = true;
    const ctl = new AbortController();
    const t = setTimeout(async () => {
      setBusy(true);
      try {
        const r = await api.get(path, { params: { q: v }, signal: ctl.signal });
        if (live) { setItems(r.data?.items || []); setError(""); }
      } catch (e) {
        const d = e?.response?.data?.detail;
        const ours = typeof d === "string" && (e.response.status < 500 || e.response.status === 503);
        if (live) { setItems([]); setError(ours ? d : "We couldn't bring the details up this time — carry on typing them in."); }
      } finally { if (live) setBusy(false); }
    }, 500);
    return () => { live = false; clearTimeout(t); ctl.abort(); };
  }, [path, q, min]);
  return { items, busy, error, clear: () => setItems([]) };
}

const isEmpty = (v) => v === "" || v === null || v === undefined;
/** A picked company into a form — only into fields still empty, so nothing already typed is lost. */
export function fillEmpty(form, values) {
  const next = { ...form };
  let filled = 0;
  for (const [k, v] of Object.entries(values)) {
    if (isEmpty(v) || !isEmpty(form[k])) continue;
    next[k] = typeof v === "number" ? String(Math.round(v)) : v;
    filled += 1;
  }
  return { next, filled };
}
